import React, {useEffect, useState} from "react";
import Select from "react-select";
import {useQuery} from "react-query";
import {ApiListResponse} from "Api/Query/ApiListResponse";
import {SelectOptionCollection} from "Model/Select/SelectOptionCollection";
import {SelectOptionType} from "Model/Select/SelectOption";
import {getDiscounts} from "Api/Query/DiscountQuery";

interface Props {
    value: any,
    onChange: (newValue: any) => void,
    classes?: string
}

export const DiscountSingleSelect: React.FC<Props> = (props) => {

    const [value, setValue] = useState<SelectOptionType | null>(null);
    const [options, setOptions] = useState<any>([]);

    const {isLoading, data} = useQuery(['discountsList'], () => getDiscounts({
        enabled: true
    }));

    useEffect(() => {
        if (!data) return;

        // @ts-ignore
        const response: ApiListResponse = data?.data;
        const collection = SelectOptionCollection.fromArray(response, 'name', 'id');
        setOptions(collection.toPrimitiveOptions());
    }, [data]);

    useEffect(() => {
        if (!props.value || !options.length) {
            return;
        }
        const selectedValue = options.find(option => option.value === props.value?.value);
        setValue(selectedValue ?? null);
    }, [props.value, options]);

    const customStyles = {
        menu: (provided) => ({
            ...provided,
            zIndex: 9999,  // Set your desired z-index value here
        }),
        menuPortal: (base) => ({
            ...base,
            zIndex: 9999,  // Set the z-index for the portal menu if you use menuPortal
        })
    };

    return (
        <Select
            isLoading={isLoading}
            options={options}
            placeholder={""}
            noOptionsMessage={() => "No hay resultados"}
            isClearable={true}
            loadingMessage={() => "Cargando ..."}
            onChange={props.onChange}
            className={props.classes ?? ''}
            value={value}
            isMulti={false}
            styles={customStyles}
        />
    );
}
